class CartUpsellEmptyCart extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
      this.attachRemoveListeners();
  } 
  attachRemoveListeners(){
    if( this.querySelectorAll('.CartDrawer__mainempty_itemswp.swiper').length > 0 ){
      new Swiper(".CartDrawer__mainempty_itemswp.swiper", { slidesPerView: "auto", spaceBetween: 16 });
    }

    if( this.querySelectorAll('[js-upsell-add]').length > 0 ){
        this.querySelectorAll('[js-upsell-add]').forEach((elm)=>{
            elm.addEventListener('click', (target)=>{
            target.preventDefault();
            let targetAddEl = target;
            targetAddEl.target.classList.add('active');
            this.querySelectorAll('[js-upsell-add]').forEach((el)=>{ el.style.pointerEvents = 'none';})
            let u_id,u_updateProduct;
            u_id = target.target.getAttribute('v-id');
            console.log(u_id);
            u_updateProduct = {'items': [{'id': u_id,'quantity': 1 }]};
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(u_updateProduct)
            }).then((response) => response.text())
            .then((responseText) => {
                this.refreshCartContent();
            }).finally(() =>{ targetAddEl.target.classList.remove('active'); }).catch((e) => { console.error(e); });          
            })
        })
    }
  }
  refreshCartContent() {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html'); const sourceQty = html.querySelector('#CartDrawer'); document.querySelector('#CartDrawer').innerHTML = sourceQty.innerHTML;
    });
    fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
    .then((response) => response.text())
    .then((responseText) => {
      const bubble_html = new DOMParser().parseFromString(responseText, 'text/html'); const bubble_sourceQty = bubble_html.querySelector('.cart-count-bubble'); document.querySelector('.cart-count-bubble').innerHTML = bubble_sourceQty.innerHTML;
    });
  }    
}

customElements.define('cus-upsell-empty-cart', CartUpsellEmptyCart);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
      this.closest('.cartDrawer__mainwrapper').querySelector(`#CartDrawer-Overlay`).addEventListener('click', this.close.bind(this));
      this.querySelector(`.CartDrawer__backbutton`).addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();      
  } 
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }  

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  } 

  setActiveElement(element) {
    this.activeElement = element;
  }
  refreshCartContent() {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html'); const sourceQty = html.querySelector('#CartDrawer'); document.querySelector('#CartDrawer').innerHTML = sourceQty.innerHTML;
    });
    fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
    .then((response) => response.text())
    .then((responseText) => {
      const bubble_html = new DOMParser().parseFromString(responseText, 'text/html'); const bubble_sourceQty = bubble_html.querySelector('.cart-count-bubble'); document.querySelector('.cart-count-bubble').innerHTML = bubble_sourceQty.innerHTML;
    });
  }
  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.querySelector(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    });

    setTimeout(() => {
      this.closest('.cartDrawer__mainwrapper').querySelector(`#CartDrawer-Overlay`).addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  // getSectionsToRender() {
  //   return [
  //     {
  //       id: 'cart-drawer',
  //       section: document.getElementById('CartDrawer').dataset.id,
  //       selector: '#CartDrawer',
  //     },
  //     {
  //       id: 'cart-icon-bubble',
  //       section: document.getElementById('cart-icon-bubble').dataset.id,
  //       selector: '.cart-icon-bubble'
  //     }
  //   ];
  // }

  getSectionsToRender() {
  const cartDrawerEl = document.getElementById('CartDrawer');
  const cartIconEl = document.getElementById('cart-icon-bubble');

  return [
    {
      id: 'cart-drawer',
      section: cartDrawerEl?.dataset?.id || 'cart-drawer',
      selector: '#CartDrawer',
    },
    {
      id: 'cart-icon-bubble',
      section: cartIconEl?.dataset?.id || 'cart-icon-bubble',
      selector: '.cart-icon-bubble'
    }
  ];
}

  onChange(event) {
    if(event.target.value !== 'on') {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
  }  

  updateQuantity(line, quantity, name,updateData = null,action = null,itemData = null) {
      this.enableLoading(line);
      let body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      let fetchUrl = routes.cart_change_url;
      this.fetchAction(fetchUrl,body); 
  }

  fetchAction(fetchUrl,body){
    fetch(`${fetchUrl}`, {...fetchConfig(), ...{ body }})
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedStateNw = JSON.parse(state);
      this.getSectionsToRender().forEach((section) => {
        const elementToReplace = section.selector
        ? document.querySelector(section.selector)
        : document.querySelector(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML( parsedStateNw.sections[section.section], section.selector );
      });
      this.disableLoading();
      this.FreeProductaddLogic(parsedStateNw);
      fetch('/cart?t=' + Math.round(+new Date() / 1000) + '&from=subscribfy')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshRecap = doc.querySelector('.exm_Cart_Recap');
          var currentRecap = document.querySelector('.exm_Cart_Recap');
          if (freshRecap && currentRecap) {
            ['subtotal', 'initial_price', 'yousave', 'exm_free_shipping'].forEach(function (attr) {
              var val = freshRecap.getAttribute(attr);
              if (val !== null) currentRecap.setAttribute(attr, val);
            });
          }
          
          // Ask Subscribfy to re-inject .exm_subtotal_summary (wiped by the #CartDrawer innerHTML replace above).
          var setExisonEl = document.getElementById('setExison');
          var isVip = setExisonEl && setExisonEl.classList.contains('exm_active') ? 1 : 0;
          document.dispatchEvent(new CustomEvent('subscribfy:triggerUpdateExmCartItems', {
            detail: { vip: isVip, forceVip: false }
          }));

          document.dispatchEvent(new CustomEvent('subscribfy:updatedExmCartItems'));
        });
    }).catch(() => {
      this.disableLoading();  
    })
  }  
  FreeProductaddLogic(cartState){

    const priceThreshold = 9000;
    if (cartState.total_price < priceThreshold) {
        const itemsToRemove = [];
        cartState.items.forEach(item => {
            if (item.properties && item.properties.upsell_offer) {
                itemsToRemove.push(item.id); 
            }
        });
        if (itemsToRemove.length > 0) {
            let updates_rmv = {};
            itemsToRemove.forEach(id => {
                updates_rmv[id] = 0;
            });
            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: updates_rmv }) 
            })
            .then(response => {
                if (!response.ok) {
                    return response.text().then(text => { throw new Error(`Cart update failed: ${response.status} - ${text}`) });
                }
                return response.json();
            })
            .then((responseText) => {
                this.refreshCartContent();
            })
            .catch(error => {
                console.error("Error during upsell item removal:", error);
            });
        }
    }
    if( cartState.total_price < 7000 ){
    
        const itemsToRemoveRs = [];
        cartState.items.forEach(item => {
            if (item.properties && item.properties.upsell_offer_rs) {
                itemsToRemoveRs.push(item.id); 
            }
        });
        if (itemsToRemoveRs.length > 0) {
            let updates_rmvrs = {};
            itemsToRemoveRs.forEach(id => {
                updates_rmvrs[id] = 0;
            });
            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: updates_rmvrs }) 
            })
            .then(response => {
                if (!response.ok) {
                    return response.text().then(text => { throw new Error(`Cart update failed: ${response.status} - ${text}`) });
                }
                return response.json();
            })
            .then((responseText) => {
                this.refreshCartContent();
            })
            .catch(error => {
                console.error("Error during upsell item removal:", error);
            });
        }

    }

    // if( cartState.total_price >= 7000 ){
    
    //     const itemsToRemoveRschk = [];
    //     cartState.items.forEach(item => {
    //         if (item.properties && item.properties.upsell_offer_rs) {
    //             itemsToRemoveRschk.push(item.id); 
    //         }
    //     });
    //     if (itemsToRemoveRschk.length == 0) {
    //         let u_idrs = 55238358499701;
    //         let u_updateProductrs = {'items': [{'id': u_idrs,'quantity': 1,'properties': {'upsell_offer_rs': 'true'} }]};              
    //         fetch(window.Shopify.routes.root + 'cart/add.js', {
    //             method: 'POST',
    //             headers: {'Content-Type': 'application/json'},
    //             body: JSON.stringify(u_updateProductrs)
    //         }).then((response) => response.text())
    //         .then((responseText) => {
    //             this.refreshCartContent();
    //         }).finally(() =>{  }).catch((e) => { console.error(e); });          
    //     }

    // }    

  }
  enableLoading() {
    if (!!document.getElementById('cart-drawer-loading')) {
     document.getElementById('cart-drawer-loading').classList.remove('hidden');
    }  
  } 
  
  disableLoading() {
    if (!!document.getElementById('cart-drawer-loading')) {
     document.getElementById('cart-drawer-loading').classList.add('hidden');
    }
  }    

}
customElements.define('cart-drawer', CartDrawer);

class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-drawer').updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);

class QuantityInputCart extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
      this.closest('cart-drawer').updateQuantity(this.querySelector('.quantity__input').dataset.index, this.input.value);
  }
}

customElements.define("cus-cart-qty", QuantityInputCart);

class cartAddSample extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.attachRemoveListeners();
    }
    attachRemoveListeners() {
        if (this.querySelectorAll('[js-upsell-add-cart]').length > 0) {
            this.querySelectorAll('[js-upsell-add-cart]').forEach((elm) => {
                elm.addEventListener('click', (target) => {
                    target.preventDefault();
                    let targetAddEl = target;
                    this.querySelectorAll('[js-upsell-add-cart]').forEach((el) => { el.style.pointerEvents = 'none'; })
                    let u_id, u_updateProduct;
                    u_id = target.target.getAttribute('data-upsell-id');
                    u_updateProduct = { 'items': [{ 'id': u_id, 'quantity': 1, 'properties': { 'upsell_offer': 'true' } }] };
                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(u_updateProduct)
                    }).then((response) => response.text())
                        .then((responseText) => {
                            this.refreshCartContent();
                        }).finally(() => { }).catch((e) => { console.error(e); });
                })
            })
        }
        if (this.querySelectorAll('[js-upsell-remove-cart]').length > 0) {
            this.querySelectorAll('[js-upsell-remove-cart]').forEach((elm) => {
                elm.addEventListener('click', (target) => {
                    target.preventDefault();
                    let u_r_id = target.target.getAttribute('data-upsell-id');
                    let updates = {};
                    updates[u_r_id] = 0;
                    fetch(window.Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ updates })
                    })
                        .then(response => {
                            return response.json();
                        })
                        .then((responseText) => {
                            this.refreshCartContent();
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                })
            })
        }
        this.scrollBox = document.querySelector('.samples__products__grid');
        this.isDragging = false;
        this.dragStartX;
        this.initialScrollX;
        this.scrollBox.addEventListener('mousedown', (event) => {
            if (event.button !== 0) {
                return;
            }
            this.isDragging = true;
            this.scrollBox.classList.add('is-dragging');
            this.dragStartX = event.pageX - this.scrollBox.offsetLeft;
            this.initialScrollX = this.scrollBox.scrollLeft;
        });
        document.addEventListener('mouseup', () => {
            if (this.isDragging) {
                this.isDragging = false;
                this.scrollBox.classList.remove('is-dragging');
            }
        });
        this.scrollBox.addEventListener('mouseleave', () => {
        });
        this.scrollBox.addEventListener('mousemove', (event) => {
            if (!this.isDragging) return;
            event.preventDefault();
            const currentX = event.pageX - this.scrollBox.offsetLeft;
            const distanceMoved = (currentX - this.dragStartX) * 1.5;
            this.scrollBox.scrollLeft = this.initialScrollX - distanceMoved;
        });
    }
    refreshCartContent() {
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html'); const sourceQty = html.querySelector('#CartDrawer'); document.querySelector('#CartDrawer').innerHTML = sourceQty.innerHTML;
            });
        fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
            .then((response) => response.text())
            .then((responseText) => {
                const bubble_html = new DOMParser().parseFromString(responseText, 'text/html'); const bubble_sourceQty = bubble_html.querySelector('.cart-count-bubble'); document.querySelector('.cart-count-bubble').innerHTML = bubble_sourceQty.innerHTML;
            });
    }

}
customElements.define("cart-add-sample", cartAddSample);


   class cartAddSample2 extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.attachRemoveListeners();
    }
    attachRemoveListeners() {


        if (this.querySelectorAll('[js-upsell-add-cart2]').length > 0) {
            this.querySelectorAll('[js-upsell-add-cart2]').forEach((elm) => {
                elm.addEventListener('click', (target) => {
                    target.preventDefault();
                    let targetAddEl = target;
                    this.querySelectorAll('[js-upsell-add-cart2]').forEach((el) => { el.style.pointerEvents = 'none'; })
                    let u_id, u_updateProduct;
                    u_id = target.target.getAttribute('data-upsell-id2');
                    u_updateProduct = { 'items': [{ 'id': u_id, 'quantity': 1, 'properties': { 'upsell_offer': 'true' } }] };
                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(u_updateProduct)
                    }).then((response) => response.text())
                        .then((responseText) => {
                            this.refreshCartContent();
                        }).finally(() => { }).catch((e) => { console.error(e); });
                })
            })
        }

        if (this.querySelectorAll('[js-upsell-remove-cart2]').length > 0) {
            this.querySelectorAll('[js-upsell-remove-cart2]').forEach((elm) => {
                elm.addEventListener('click', (target) => {
                    target.preventDefault();
                    let u_r_id = target.target.getAttribute('data-upsell-id2');
                    let updates = {};
                    updates[u_r_id] = 0;
                    fetch(window.Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ updates })
                    })
                        .then(response => {
                            return response.json();
                        })
                        .then((responseText) => {
                            this.refreshCartContent();
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });

                })
            })
        }



        this.scrollBox = document.querySelector('.samples__products__grid2');
        this.isDragging = false;
        this.dragStartX;
        this.initialScrollX;
        this.scrollBox.addEventListener('mousedown', (event) => {
            if (event.button !== 0) {
                return;
            }
            this.isDragging = true;
            this.scrollBox.classList.add('is-dragging');
            this.dragStartX = event.pageX - this.scrollBox.offsetLeft;
            this.initialScrollX = this.scrollBox.scrollLeft;
        });
        document.addEventListener('mouseup', () => {
            if (this.isDragging) {
                this.isDragging = false;
                this.scrollBox.classList.remove('is-dragging');
            }
        });
        this.scrollBox.addEventListener('mouseleave', () => {
        });
        this.scrollBox.addEventListener('mousemove', (event) => {
            if (!this.isDragging) return;
            event.preventDefault();
            const currentX = event.pageX - this.scrollBox.offsetLeft;
            const distanceMoved = (currentX - this.dragStartX) * 1.5;
            this.scrollBox.scrollLeft = this.initialScrollX - distanceMoved;
        });
        

    }
    refreshCartContent() {
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html'); const sourceQty = html.querySelector('#CartDrawer'); document.querySelector('#CartDrawer').innerHTML = sourceQty.innerHTML;
            });
        fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
            .then((response) => response.text())
            .then((responseText) => {
                const bubble_html = new DOMParser().parseFromString(responseText, 'text/html'); const bubble_sourceQty = bubble_html.querySelector('.cart-count-bubble'); document.querySelector('.cart-count-bubble').innerHTML = bubble_sourceQty.innerHTML;
            });
    }

}
customElements.define("cart-add-sample2", cartAddSample2);



// --------------------------------------
// GLOBAL CART REFRESH FUNCTION
// --------------------------------------
function refreshCartContent() {
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const sourceQty = html.querySelector('#CartDrawer');
      document.querySelector('#CartDrawer').innerHTML = sourceQty.innerHTML;
    });

  fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
    .then((response) => response.text())
    .then((responseText) => {
      const bubble_html = new DOMParser().parseFromString(responseText, 'text/html');
      const bubble_sourceQty = bubble_html.querySelector('.cart-count-bubble');
      document.querySelector('.cart-count-bubble').innerHTML = bubble_sourceQty.innerHTML;
    });
}


// --------------------------------------
// VIP ADDED EVENT
// --------------------------------------
document.addEventListener('subscribfy:VIPAddedToCart', function () {

  fetch('/cart.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
  .then(res => res.json())
  .then(cartData => {

    console.log(cartData.total_price);

    const priceThreshold = 9000;

    // ---------------------------
    // REMOVE UPSELL IF BELOW 9000
    // ---------------------------
    if (cartData.total_price < priceThreshold) {
      const itemsToRemove = [];

      cartData.items.forEach(item => {
        if (item.properties && item.properties.upsell_offer) {
          itemsToRemove.push(item.id);
        }
      });

      if (itemsToRemove.length > 0) {
        let updates_rmv = {};
        itemsToRemove.forEach(id => updates_rmv[id] = 0);

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates_rmv })
        })
        .then(r => r.json())
        .then(() => refreshCartContent())
        .catch(err => console.error("Error removing upsell:", err));
      }
    }

    // ---------------------------
    // REMOVE Rs UPSELL BELOW 7000
    // ---------------------------
    // if (cartData.total_price < 7000) {
    //   const itemsToRemoveRs = [];

    //   cartData.items.forEach(item => {
    //     if (item.properties && item.properties.upsell_offer_rs) {
    //       itemsToRemoveRs.push(item.id);
    //     }
    //   });

    //   if (itemsToRemoveRs.length > 0) {
    //     let updates_rmvrs = {};
    //     itemsToRemoveRs.forEach(id => updates_rmvrs[id] = 0);

    //     fetch('/cart/update.js', {
    //       method: 'POST',
    //       headers: { 'Content-Type': 'application/json' },
    //       body: JSON.stringify({ updates: updates_rmvrs })
    //     })
    //     .then(r => r.json())
    //     .then(() => refreshCartContent())
    //     .catch(err => console.error("Error removing upsell Rs:", err));
    //   }
    // }

    // ---------------------------
    // ADD Rs UPSELL IF ABOVE 7000
    // ---------------------------
    // if (cartData.total_price >= 7000) {
    //   const itemsToRemoveRschk = [];

    //   cartData.items.forEach(item => {
    //     if (item.properties && item.properties.upsell_offer_rs) {
    //       itemsToRemoveRschk.push(item.id);
    //     }
    //   });

    //   if (itemsToRemoveRschk.length === 0) {
    //     const u_updateProductrs = {
    //       items: [{
    //         id: 55238358499701,
    //         quantity: 1,
    //         properties: { 'upsell_offer_rs': 'true' }
    //       }]
    //     };

    //     fetch('/cart/add.js', {
    //       method: 'POST',
    //       headers: { 'Content-Type': 'application/json' },
    //       body: JSON.stringify(u_updateProductrs)
    //     })
    //     .then(r => r.text())
    //     .then(() => refreshCartContent())
    //     .catch(err => console.error(err));
    //   }
    // }
  })
  .catch(err => console.error("Cart fetch error:", err));
});


// --------------------------------------
// VIP REMOVED EVENT
// (Same logic – fully corrected)
// --------------------------------------
document.addEventListener('subscribfy:VIPRemovedFromCart', function () {

  fetch('/cart.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
  .then(res => res.json())
  .then(cartData => {

    console.log(cartData.total_price);

    const priceThreshold = 9000;

    // REMOVE UPSELL BELOW 9000
    if (cartData.total_price < priceThreshold) {
      const itemsToRemove = [];

      cartData.items.forEach(item => {
        if (item.properties && item.properties.upsell_offer) {
          itemsToRemove.push(item.id);
        }
      });

      if (itemsToRemove.length > 0) {
        let updates_rmv = {};
        itemsToRemove.forEach(id => updates_rmv[id] = 0);

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates_rmv })
        })
        .then(r => r.json())
        .then(() => refreshCartContent())
        .catch(err => console.error("Error removing upsell:", err));
      }
    }

    // REMOVE Rs UPSELL BELOW 7000
    if (cartData.total_price < 7000) {
      const itemsToRemoveRs = [];

      cartData.items.forEach(item => {
        if (item.properties && item.properties.upsell_offer_rs) {
          itemsToRemoveRs.push(item.id);
        }
      });

      if (itemsToRemoveRs.length > 0) {
        let updates_rmvrs = {};
        itemsToRemoveRs.forEach(id => updates_rmvrs[id] = 0);

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates_rmvrs })
        })
        .then(r => r.json())
        .then(() => refreshCartContent())
        .catch(err => console.error("Error removing upsell Rs:", err));
      }
    }

    // ADD Rs UPSELL IF ABOVE 7000
    // if (cartData.total_price >= 7000) {
    //   const itemsToRemoveRschk = [];

    //   cartData.items.forEach(item => {
    //     if (item.properties && item.properties.upsell_offer_rs) {
    //       itemsToRemoveRschk.push(item.id);
    //     }
    //   });

    //   if (itemsToRemoveRschk.length === 0) {
    //     const u_updateProductrs = {
    //       items: [{
    //         id: 55238358499701,
    //         quantity: 1,
    //         properties: { 'upsell_offer_rs': 'true' }
    //       }]
    //     };

    //     fetch('/cart/add.js', {
    //       method: 'POST',
    //       headers: { 'Content-Type': 'application/json' },
    //       body: JSON.stringify(u_updateProductrs)
    //     })
    //     .then(r => r.text())
    //     .then(() => refreshCartContent())
    //     .catch(err => console.error(err));
    //   }
    // }
  })
  .catch(err => console.error("Cart fetch error:", err));
});



//     document.addEventListener('subscribfy:VIPAddedToCart', function (evt) {
// 	fetch('/cart.js', {
//               method: 'POST',
//               headers: {
//                 'Accept': 'application/json',
//                 'Content-Type': 'application/json'
//               }
//             })
//             .then(response => {
//               if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//               }
//               return response.json(); 
//             })
//             .then(cartData => {
 
//               console.log(cartData.total_price);
 
//               const priceThreshold = 9000;
//               if (cartData.total_price < priceThreshold) {
//                   const itemsToRemove = [];
//                   cartData.items.forEach(item => {
//                       if (item.properties && item.properties.upsell_offer) {
//                           itemsToRemove.push(item.id); 
//                       }
//                   });
//                   if (itemsToRemove.length > 0) {
//                       let updates_rmv = {};
//                       itemsToRemove.forEach(id => {
//                           updates_rmv[id] = 0;
//                       });
//                       fetch(window.Shopify.routes.root + 'cart/update.js', {
//                           method: 'POST',
//                           headers: { 'Content-Type': 'application/json' },
//                           body: JSON.stringify({ updates: updates_rmv }) 
//                       })
//                       .then(response => {
//                           if (!response.ok) {
//                               return response.text().then(text => { throw new Error(`Cart update failed: ${response.status} - ${text}`) });
//                           }
//                           return response.json();
//                       })
//                       .then((responseText) => {
//                           this.refreshCartContent();
//                       })
//                       .catch(error => {
//                           console.error("Error during upsell item removal:", error);
//                       });
//                   }
//               }
//               if( cartData.total_price < 7000 ){
              
//                   const itemsToRemoveRs = [];
//                   cartData.items.forEach(item => {
//                       if (item.properties && item.properties.upsell_offer_rs) {
//                           itemsToRemoveRs.push(item.id); 
//                       }
//                   });
//                   if (itemsToRemoveRs.length > 0) {
//                       let updates_rmvrs = {};
//                       itemsToRemoveRs.forEach(id => {
//                           updates_rmvrs[id] = 0;
//                       });
//                       fetch(window.Shopify.routes.root + 'cart/update.js', {
//                           method: 'POST',
//                           headers: { 'Content-Type': 'application/json' },
//                           body: JSON.stringify({ updates: updates_rmvrs }) 
//                       })
//                       .then(response => {
//                           if (!response.ok) {
//                               return response.text().then(text => { throw new Error(`Cart update failed: ${response.status} - ${text}`) });
//                           }
//                           return response.json();
//                       })
//                       .then((responseText) => {
//                           this.refreshCartContent();
//                       })
//                       .catch(error => {
//                           console.error("Error during upsell item removal:", error);
//                       });
//                   }
 
//               }
 
//               if( cartData.total_price >= 7000 ){
              
//                   const itemsToRemoveRschk = [];
//                   cartData.items.forEach(item => {
//                       if (item.properties && item.properties.upsell_offer_rs) {
//                           itemsToRemoveRschk.push(item.id); 
//                       }
//                   });
//                   console.log(itemsToRemoveRschk);
//                   if (itemsToRemoveRschk.length == 0) {
//                       let u_idrs = 55238358499701;
//                       let u_updateProductrs = {'items': [{'id': u_idrs,'quantity': 1,'properties': {'upsell_offer_rs': 'true'} }]};              
//                       fetch(window.Shopify.routes.root + 'cart/add.js', {
//                           method: 'POST',
//                           headers: {'Content-Type': 'application/json'},
//                           body: JSON.stringify(u_updateProductrs)
//                       }).then((response) => response.text())
//                       .then((responseText) => {
//                           this.refreshCartContent();
//                       }).finally(() =>{  }).catch((e) => { console.error(e); });          
//                   }
 
//               }
 
 
//             })
//             .catch(error => {
//                 console.error("There was a problem with the cart fetch operation:", error);
//             });
// });
// document.addEventListener('subscribfy:VIPRemovedFromCart', function (evt) {
// 	fetch('/cart.js', {
//               method: 'POST',
//               headers: {
//                 'Accept': 'application/json',
//                 'Content-Type': 'application/json'
//               }
//             })
//             .then(response => {
//               if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//               }
//               return response.json(); 
//             })
//             .then(cartData => {
 
//               console.log(cartData.total_price);
 
//               const priceThreshold = 9000;
//               if (cartData.total_price < priceThreshold) {
//                   const itemsToRemove = [];
//                   cartData.items.forEach(item => {
//                       if (item.properties && item.properties.upsell_offer) {
//                           itemsToRemove.push(item.id); 
//                       }
//                   });
//                   if (itemsToRemove.length > 0) {
//                       let updates_rmv = {};
//                       itemsToRemove.forEach(id => {
//                           updates_rmv[id] = 0;
//                       });
//                       fetch(window.Shopify.routes.root + 'cart/update.js', {
//                           method: 'POST',
//                           headers: { 'Content-Type': 'application/json' },
//                           body: JSON.stringify({ updates: updates_rmv }) 
//                       })
//                       .then(response => {
//                           if (!response.ok) {
//                               return response.text().then(text => { throw new Error(`Cart update failed: ${response.status} - ${text}`) });
//                           }
//                           return response.json();
//                       })
//                       .then((responseText) => {
//                           this.refreshCartContent();
//                       })
//                       .catch(error => {
//                           console.error("Error during upsell item removal:", error);
//                       });
//                   }
//               }
//               if( cartData.total_price < 7000 ){
              
//                   const itemsToRemoveRs = [];
//                   cartData.items.forEach(item => {
//                       if (item.properties && item.properties.upsell_offer_rs) {
//                           itemsToRemoveRs.push(item.id); 
//                       }
//                   });
//                   if (itemsToRemoveRs.length > 0) {
//                       let updates_rmvrs = {};
//                       itemsToRemoveRs.forEach(id => {
//                           updates_rmvrs[id] = 0;
//                       });
//                       fetch(window.Shopify.routes.root + 'cart/update.js', {
//                           method: 'POST',
//                           headers: { 'Content-Type': 'application/json' },
//                           body: JSON.stringify({ updates: updates_rmvrs }) 
//                       })
//                       .then(response => {
//                           if (!response.ok) {
//                               return response.text().then(text => { throw new Error(`Cart update failed: ${response.status} - ${text}`) });
//                           }
//                           return response.json();
//                       })
//                       .then((responseText) => {
//                           this.refreshCartContent();
//                       })
//                       .catch(error => {
//                           console.error("Error during upsell item removal:", error);
//                       });
//                   }
 
//               }
 
//               if( cartData.total_price >= 7000 ){
              
//                   const itemsToRemoveRschk = [];
//                   cartData.items.forEach(item => {
//                       if (item.properties && item.properties.upsell_offer_rs) {
//                           itemsToRemoveRschk.push(item.id); 
//                       }
//                   });
//                   console.log(itemsToRemoveRschk);
//                   if (itemsToRemoveRschk.length == 0) {
//                       let u_idrs = 55238358499701;
//                       let u_updateProductrs = {'items': [{'id': u_idrs,'quantity': 1,'properties': {'upsell_offer_rs': 'true'} }]};              
//                       fetch(window.Shopify.routes.root + 'cart/add.js', {
//                           method: 'POST',
//                           headers: {'Content-Type': 'application/json'},
//                           body: JSON.stringify(u_updateProductrs)
//                       }).then((response) => response.text())
//                       .then((responseText) => {
//                           this.refreshCartContent();
//                       }).finally(() =>{  }).catch((e) => { console.error(e); });          
//                   }
 
//               }
 
 
//             })
//             .catch(error => {
//                 console.error("There was a problem with the cart fetch operation:", error);
//             });


            
// });
